import { openSizeChart } from '@nykaa/size-chart-desktop/utils';
import { SIZE_CHART_LIST } from '@nykaa/size-chart-shared/constants';
import { ListingProduct } from '@nykaa/product-card-shared/types';
import { events } from '@nykaa/data-layer/constants';
import { pushEvent } from '@nykaa/data-layer/utils';
import { UnitProps } from 'store/product/types';

export const handleSizeChart = (
  columns: UnitProps[],
  product: ListingProduct
) => {
  const sizeChartList = document?.getElementById(SIZE_CHART_LIST);
  if (sizeChartList) {
    sizeChartList.style.height = '68%';
  }
  pushEvent(events.SIZE_CHART_CLICK, { clickedProduct: { ...product } });
  openSizeChart(columns);
};
